"use client";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

import { IconInput } from "ui/core/input";

import { useSearch } from "../context/search-context";

interface ArticleSearchProps {
  searchPlaceholder: string;
}

export function ArticleSearch({ searchPlaceholder }: ArticleSearchProps) {
  const { searchQuery, setSearchQuery, setSearching } = useSearch();
  const [inputValue, setInputValue] = useState(searchQuery);

  useEffect(() => {
    // this is a hack to prevent the search from being too sensitive
    setSearching(true);
    const timeout = setTimeout(() => {
      setSearching(false);
      setSearchQuery(inputValue);
    }, 500);
    return () => clearTimeout(timeout);
  }, [inputValue, setSearching, setSearchQuery]);

  return (
    <div className="mb-4">
      <IconInput
        type="text"
        name="search"
        placeholder={searchPlaceholder}
        leadingIcon={<MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        aria-label={searchPlaceholder}
        role="searchbox"
        data-testid="search-input"
      />
    </div>
  );
}
